module.exports = __webpack_public_path__ + "img/491.b3ed5076.jpg";